import {Col, Form, Row} from 'react-bootstrap'
import Select from 'react-select'
import {FormattedMessage, useIntl} from 'react-intl'
import {COUNTRIES, MARITAL_STATUS} from '../../../../../helpers/consts'
import {maritalStatusLabel} from '../../../../../helpers/catalogMessages'
import {TFormMemberPolicy} from '../../../../policies/policiesTypes'
import {HeightInput} from 'app/tfi/components/HeightInput'

interface SpecificInformationMemberProps {
  membernum: number
  values: TFormMemberPolicy
  handleChange: (field: string, value: string) => void
}

export const SpecificInformationMember: React.FC<SpecificInformationMemberProps> = ({
  membernum,
  values,
  handleChange,
}) => {
  const intl = useIntl()
  // console.log('SpecificInformationMember:' + JSON.stringify(values))
  return (
    <Row>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`maritalStatus_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.maritalStatus'
              defaultMessage='Marital status'
            />
          </Form.Label>
          <Form.Select
            name={`maritalStatus_${membernum}`}
            id={`maritalStatus_${membernum}`}
            value={values.maritalStatus ?? ''}
            onChange={(e) => handleChange('maritalStatus', e.target.value)}
            aria-label={intl.formatMessage({
              id: 'policies.detail.form.member.maritalStatus',
              defaultMessage: 'Marital status',
            })}
          >
            <option value=''>
              {intl.formatMessage({id: 'common.placeholder.selectOption', defaultMessage: 'Select an option'})}
            </option>
            {MARITAL_STATUS.map((mari) => (
              <option key={mari} value={mari}>
                {maritalStatusLabel(intl, mari)}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`countryBirth_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.countryBirth'
              defaultMessage='Country of birth'
            />
          </Form.Label>
          <Select
            inputId={`countryBirth_${membernum}`}
            value={COUNTRIES.find((opt) => opt.value === values.countryBirth) || null}
            onChange={(option) => {
              const value = option ? option.value : ''
              handleChange('countryBirth', value)
            }}
            options={COUNTRIES}
            styles={{control: (base) => ({...base, padding: '3px 0'})}}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`weight_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.weight'
              defaultMessage='Weight (lbs)'
            />
          </Form.Label>
          <Form.Control
            type='number'
            value={values.weight ?? ''}
            name={`weight_${membernum}`}
            id={`weight_${membernum}`}
            placeholder={intl.formatMessage({id: 'policies.detail.form.member.enterWeight', defaultMessage: 'Enter weight'})}
            onChange={(e) => {
              handleChange('weight', e.target.value)
            }}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`height_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.height'
              defaultMessage='Height'
            />
          </Form.Label>
          {/* Acepta 5'10", 5 10, 5.10 o 70; guarda siempre pulgadas totales. */}
          <HeightInput
            value={values.height}
            name={`height_${membernum}`}
            id={`height_${membernum}`}
            onChange={(inches) => handleChange('height', inches)}
          />
        </Form.Group>
      </Col>
    </Row>
  )
}
